module.exports = __webpack_public_path__ + "static/fonts/iconfont.32eaa526.ttf";